import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { auth } from "firebase/app";
import { AngularFireAuth } from "@angular/fire/auth";
import { User } from "firebase";
import { AngularFireDatabase } from "@angular/fire/database";
import { fbUser, fbCartItem } from "../Models/fbUser";
import { Observable, BehaviorSubject, Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { EmbryoService } from "./Embryo.service";

@Injectable({
  providedIn: "root"
})
export class AuthService 
{
  user: BehaviorSubject<User> = new BehaviorSubject<User>(null);
  returnUrl: string = "";
  USERKEY: string = "user";
  authSubscription:Subscription;

  constructor(
    public afAuth: AngularFireAuth,
    public router: Router,
    public ngZone: NgZone,
    public db: AngularFireDatabase
  ) 
  {
    this.authSubscription = this.afAuth.authState.subscribe(user => {
      if (user) {
        this.user.next(user);
        //this.SaveUserToLocal(user);
        
      } else {
        this.user.next(null);
        //this.SaveUserToLocal(null);
      }
    });
  }

  ngOnDestroy(): void {
    this.authSubscription.unsubscribe();
  }
  getUser() : Promise<any>{
      return this.afAuth.authState.pipe(first()).toPromise();
  }

  async login(email: string, password: string, returnUrl = "") {
    try {
      await this.afAuth.auth
        .signInWithEmailAndPassword(email, password)
        .then(result => {

        });
      if (returnUrl !== "")
        this.router.navigate([returnUrl]);
      else
        this.router.navigate(["account/profile"]);
    } catch (e) {
      alert("Error!" + e.message);
    }
  }

  SignUp(firstname, lastname, email, password) {
    return this.afAuth.auth
      .createUserWithEmailAndPassword(email, password)
      .then(result => {
        /* Call the SendVerificaitonMail() function when new user sign 
            up and returns promise */
        this.SendVerificationMail();
        this.CreateUserObjectOnDB(firstname, lastname, result.user);
      })
      .catch(error => {
        alert(error.message);
      });
  }

  ForgotPassword(passwordResetEmail) {
    return this.afAuth.auth
      .sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        alert("Password reset email sent, check your inbox.");
      })
      .catch(error => {
        alert(error);
      });
  }

  // Sign in with Google
  GoogleAuth() {
    return this.AuthLogin(new auth.GoogleAuthProvider());
  }
  // Auth logic to run auth providers
  AuthLogin(provider) {
    return this.afAuth.auth
      .signInWithPopup(provider)
      .then(result => {
        this.ngZone.run(async() => {
          //this.SaveUserToLocal(result.user)
          this.user.next(result.user);
          if (!await this.CheckIfUserExistInFB(result.user.uid))
            this.CreateUserObjectOnDB(result.user.displayName, "", result.user);
          this.router.navigate(["account/profile"]);
        });
      })
      .catch(error => {
        window.alert(error);
      });
  }

  async logout() {
    await this.afAuth.auth.signOut();
    //this.SaveUserToLocal(null);
    this.user.next(null);
    this.router.navigate(["home"]);
  }

  get isLoggedIn(): boolean {
    return this.user.value !== null;
  }

  CreateUserObjectOnDB(firstname: string, lastname: string, currentUser: User) {
    this.db
      .object("/users/" + currentUser.uid)
      .remove()
      .catch();

    let tempUser: fbUser = new fbUser(currentUser, firstname, lastname);
    tempUser.card.cartItems.push(new fbCartItem("","",0,0,0,"","","",""));
    this.db
      .list("/users")
      .push(tempUser)
      .then();
  }

  SendVerificationMail() {
    return this.afAuth.auth.currentUser.sendEmailVerification().then(() => {
      this.router.navigate(["account/profile"]);
    });
  }
  
  async CheckIfUserExistInFB(uid: string) {
    return await this.db.object("/users/"+ uid).valueChanges().pipe(first()).toPromise();
  }
  GetUserInFB(uid: string): Observable<any> {
    return this.db.object("/users/" + uid).valueChanges();
  }

  GetCurrentUserIdToken(): Promise<string> {
    return this.afAuth.auth.currentUser.getIdToken(true);
  }

  SaveUserToLocal(user:User){
    localStorage.setItem(this.USERKEY,JSON.stringify( user));
  }
}
